import React, {ForwardedRef, forwardRef} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const Body4 = forwardRef(
  (
    {children, className}: {children: React.ReactNode; className?: string},
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    return (
      <p
        ref={ref}
        className={cn(
          'lg:text-lg',
          'text-base',
          'text-gray-800',
          'font-normal',
          'leading-normal tracking-wide',
          className
        )}>
        {children}
      </p>
    )
  }
)

Body4.displayName = 'Body4'

export default Body4
